import { render, staticRenderFns } from "./milestones-section.vue?vue&type=template&id=614d023e&scoped=true&"
import script from "./milestones-section.vue?vue&type=script&lang=ts&"
export * from "./milestones-section.vue?vue&type=script&lang=ts&"
import style0 from "./milestones-section.vue?vue&type=style&index=0&id=614d023e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "614d023e",
  null
  
)

export default component.exports